// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import startHtmlUrl from 'bender-url!connect-dot-com-ui/html/third-party-cookie-test.html';
/**
 * Checks if third-party cookies are enabled or not
 * on the current browser session.
 *
 * @returns {Promise<Boolean>}
 *  A promise that will always resolve with a boolean indicating if third-party cookies are enabled or not.
 */

export const checkThirdPartyCookies = () => {
  return new Promise(resolve => {
    try {
      const iframe = document.createElement('iframe');
      iframe.id = 'signup-ui-third-party-cookies-iframe';
      iframe.src = startHtmlUrl;
      iframe.style.display = 'none';

      const receiveMessage = function receiveMessage(evt) {
        if (evt.data.source === 'signup-ui-third-party-cookies-message') {
          resolve(evt.data.enabled);

          if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          window.removeEventListener('message', receiveMessage, false);
        }
      };

      window.addEventListener('message', receiveMessage, false);
      document.body.appendChild(iframe);
    } catch (err) {
      resolve(false);
    }
  });
};